import { z } from 'zod';

export const BaseErrorSchema = z.object({
  // Prevent our error types from being mixed up with `Error` in JavaScript.
  reason: z.never().optional(),
  Reason: z.never().optional(),
  name: z.never().optional(),
  Name: z.never().optional(),
  cause: z.never().optional(),
  Cause: z.never().optional(),
  error: z.never().optional(),
  Error: z.never().optional(),
  errorMessage: z.never().optional(),
  ErrorMessage: z.never().optional(),
  message: z.never().optional(),
  Message: z.never().optional(),
  baseError: z.never().optional(),
  BaseError: z.never().optional(),
  stackTraces: z.array(z.array(z.string())).optional(),
});
